import z from 'zod/v4';
import { dataResponseSchema } from './data-response';
import { absoluteTimeRangeSchema } from './utils';

export const snapshotMetadataSchema = z.object({
  timeRange: absoluteTimeRangeSchema.optional(),
});

export const snapshotResultSchema = z.object({
  dataResponse: dataResponseSchema,
  version: z.number(),
});

export const dataSnapshotSchema = z.object({
  results: z.array(snapshotResultSchema),
  metadata: snapshotMetadataSchema,
});

export type DataSnapshotSchema = z.infer<typeof dataSnapshotSchema>;
